import { render, staticRenderFns } from "./risk-result.vue?vue&type=template&id=3e17f6f6&"
import script from "./risk-result.vue?vue&type=script&lang=js&"
export * from "./risk-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports